module.exports = __webpack_public_path__ + "static/media/insure-finance-landing-page.89119659.jpg";